import { render, staticRenderFns } from "./RiskParameters.vue?vue&type=template&id=33c5f89d&scoped=true&"
import script from "./RiskParameters.vue?vue&type=script&lang=js&"
export * from "./RiskParameters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c5f89d",
  null
  
)

export default component.exports